module.exports = __webpack_public_path__ + "media/images/shop_dashborad_image-b343261505f1b67c720fd9cf4d8f82e3.png";